import gsap from "../../../../helpers/gsapInstance";
import MainPageThirdScreenCommon from "./MainPageThirdScreenCommon";
import {MAX_MOBILE_WIDTH} from "../../../../constans";
import {MainPageTypes} from "../../../../types/main-page";
import ThirdScreenSwitchAngleViewTypeEnum = MainPageTypes.ThirdScreenSwitchAngleViewTypeEnum;
import ClickEvent = JQuery.ClickEvent;

export default class MainPageThirdScreenMobile extends MainPageThirdScreenCommon {
    private selectedPointKey: string | number | null = null;

    constructor($holder: JQuery) {
        super($holder);

        this.setPointsPercents();

        this.changeActivePointOnThirdScreen = this.changeActivePointOnThirdScreen.bind(this);
    }

    /**
     * Задать начальные проценты для анимаций для телефона
     * @private
     */
    private setPointsPercents(): void {
        const MOBILE_PERCENTS: number = 200;

        if (this.isMobilePhone()) {
            this.STARTED_PERCENTS = MOBILE_PERCENTS;
            this.ADDING_PERCENTS = MOBILE_PERCENTS;
        }
    }

    /**
     * Инициировать все события для 3 экрана на мобилке и планшете
     * @public
     */
    public initMobileEvents(): void {
        this.initEvents();

        if (this.isMobilePhone()) {
            this.$mainContainer.off().on('click', this.changeActivePointOnThirdScreen);
        }
    }

    /**
     * Инициировать все события, связанные со скроллром и анимацией для 3 экрана на мобилке и планшете
     * @public
     */
    public async initScreenScrollingAnimations(): Promise<void> {
        this.initSlideTopAndBottomContentOnScrollingAnimation();
        await this.setDefaultProps();
        this.initSlideMainContentOnScrollingAnimation();
    }

    /**
     * Инициализация анимации для сдвига верхнего и нижнего контента снизу-вверх
     * @private
     */
    private initSlideTopAndBottomContentOnScrollingAnimation(): void {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.$screen,
                start: "top center",
            },
        });

        tl.fromTo(
            [this.$topContent, this.$bottomContent],
            {
                transform: 'translateY(30%)',
                opacity: 0,
            },
            {
                transform: 'translateY(0%)',
                opacity: 1,
                duration: 0.6
            },
        )
    }

    /**
     * Инициализация анимации для сдвига центрального контента в виде картинки снизу-вверх
     * @private
     */
    private initSlideMainContentOnScrollingAnimation(): void {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.$screen,
                start: "25% center"
            },
        });

        tl.fromTo(
            [this.$mainBackground],
            {
                transform: 'translate(-50%, 80%) scale(2)',
                opacity: 0,
            },
            {
                transform: 'translate(-50%, 200%) scale(5)',
                opacity: 1,
                duration: 0.6
            },
        );

        tl.to(this.$mainBackground, {
            onStart: async () => {
                await this.setStartAnimationForPoints();
            }
        })
    }

    /**
     * Функция обработчик клика на каждый отдельный point для открытия тултипа на третьем экране только для мобилки
     * @private
     * @param event
     */
    public changeActivePointOnThirdScreen(event: ClickEvent): void {
        const primaryPointsItems = this.selectors.primaryPointsItems;
        const secondaryPointsItems = this.selectors.secondaryPointsItems;
        const angleViewType = this.$mainContainer.data('type');

        // Проверяем на то, какой тип сейчас активный из dataset у this.$mainContainer
        let isPrimaryAngleView = angleViewType === ThirdScreenSwitchAngleViewTypeEnum.PRIMARY;

        // Исходя из активного типа выбираем ближайший кликнутый элемент
        const target = event.target.closest(isPrimaryAngleView ? primaryPointsItems : secondaryPointsItems);
        const $items = isPrimaryAngleView ? this.$primaryPointsItems : this.$secondaryPointsItems;

        // Проходим по всем элементам, исходя из типа и удаляем активный класс, в любом случае при любом клике они удаляются, чтобы очистить экран
        $items.each((_, item) => {
            const $item = $(item);

            if ($item.hasClass(this.ACTIVE_CLASS)) {
                $item.removeClass(this.ACTIVE_CLASS);
            }
        });

        if (target) {
            if (this.selectedPointKey === target.dataset.key) {
                target.classList.remove(this.ACTIVE_CLASS);
                this.selectedPointKey = null;
            } else {
                target.classList.add(this.ACTIVE_CLASS);
                this.selectedPointKey = target.dataset.key;
            }
        }
    }
}
